import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export function SidebarSection({
  children,
  defaultOpen,
  title,
  tooltip = ''
}) {
  return /*#__PURE__*/_jsx(AccordionItem, {
    defaultOpen: defaultOpen,
    title: /*#__PURE__*/_jsx(Tooltip, {
      delay: 200,
      disabled: !tooltip,
      placement: "right",
      title: tooltip,
      children: /*#__PURE__*/_jsx("span", {
        children: title
      })
    }),
    titleTagName: "h6",
    children: /*#__PURE__*/_jsx(View, {
      paddingBlockStart: "0",
      as: "div",
      children: children
    })
  });
}